/**
 * Page Container Component
 * Provides consistent padding and max-width for page content
 */

import React from 'react';
import { spacing, colors } from '../../theme/designTokens';

/**
 * PageContainer Component
 *
 * @param {ReactNode} children - Content to render
 * @param {boolean} fluid - If true, removes max-width constraint
 * @param {string} maxWidth - Custom max width (default: 1600px)
 * @param {object} style - Additional styles
 */
function PageContainer({
  children,
  fluid = false,
  maxWidth = '1600px',
  style = {},
}) {
  return (
    <div
      style={{
        padding: `${spacing.xxs}px ${spacing.xxs}px`,  // Aggressive minimal: 4px all around
        minHeight: '100%', // Use 100% instead of vh calculation
        backgroundColor: colors.background.default,
        maxWidth: fluid ? '100%' : maxWidth,
        margin: '0 auto',
        width: '100%',
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export default PageContainer;
